export default "__VITE_ASSET__BJmfzxMK__"